import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'label']

  static values = {
    loadingLabel: String,
    readyLabel: String
  }

  connect() {
    this.originalLabel = this.hasLabelTarget ? this.labelTarget.textContent : ''
  }

  async open(event) {
    event.preventDefault()

    if (this.launchUrl) {
      this.openInNewTab()
      return
    }
    if (this.loading) return

    this.loading = true
    this.setButtonState(true, this.loadingLabelValue)

    try {
      const response = await fetch(this.element.action, {
        method: 'POST',
        body: new FormData(this.element),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })

      if (!response.headers.get('content-type')?.includes('application/json')) {
        window.location.assign(response.url)
        return
      }
      if (!response.ok) throw new Error(`Contact reveal failed with status ${response.status}`)

      const result = await response.json()
      this.launchUrl = result.launch_url
      this.setButtonState(false, this.readyLabelValue)

      // This usually opens WhatsApp immediately. If the browser blocks a new tab
      // after the request, the enabled button opens it directly on the next tap.
      this.openInNewTab()
    } catch {
      this.setButtonState(false, this.originalLabel)
    } finally {
      this.loading = false
    }
  }

  openInNewTab() {
    window.open(this.launchUrl, '_blank', 'noopener,noreferrer')
  }

  setButtonState(disabled, label) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = disabled
      this.buttonTarget.setAttribute('aria-busy', disabled.toString())
    }
    if (this.hasLabelTarget && label) this.labelTarget.textContent = label
  }
}
